<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">错误日志</div>
        <el-form class="zj-search-form" ref="form" :model="form" :label-width="labelWidth">
          <el-form-item label="用户名" prop="UserName">
            <el-input v-model="UserName" placeholder="请输入用户名"></el-input>
          </el-form-item>
          <el-form-item label="开始时间">
            <el-date-picker
              placeholder="选择日期"
              v-model="BeginTime"
              type="datetime"
              format="yyyy-MM-dd HH:mm"
              :clearable="false"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间">
            <el-date-picker
              placeholder="选择日期"
              v-model="EndTime"
              type="datetime"
              format="yyyy-MM-dd HH:mm"
              :clearable="false"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="模块名" prop="ModuleName">
            <el-input v-model="ModuleName" placeholder="请输入模块名"></el-input>
          </el-form-item>
          <el-form-item label="页面名" prop="PageName">
            <el-input v-model="PageName" placeholder="请输入页面名"></el-input>
          </el-form-item>
          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table
              :data="tableData"
              ref="multipleTable"
              border
              style="width: 100%"
              fixed
              :tooltip-effect="light"
            >
              <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
              <el-table-column prop="UserName" label="用户名"></el-table-column>
              <el-table-column prop="ModuleName" label="所属模块">
                <template slot-scope="scope">
                  <el-popover placement="top-start" title="所属模块" width="250" trigger="hover">
                    <div>{{scope.row.ModuleName}}</div>
                    <span
                      slot="reference"
                    >{{ scope.row.ModuleName.length>20?scope.row.ModuleName.substr(0,20)+'...':scope.row.ModuleName }}</span>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column prop="PageName" label="所属页面">
                <template slot-scope="scope">
                  <el-popover placement="top-start" title="所属页面" width="250" trigger="hover">
                    <div>{{scope.row.PageName}}</div>
                    <span
                      slot="reference"
                    >{{ scope.row.PageName.length>20?scope.row.PageName.substr(0,20)+'...':scope.row.PageName }}</span>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column prop="LogDate" label="时间" :formatter="formatDate" width="200"></el-table-column>
              <el-table-column prop="LogMessage" label="内容">
                <template slot-scope="scope">
                  <el-popover placement="top-start" title="内容" width="300" trigger="hover">
                    <div>{{scope.row.LogMessage}}</div>
                    <span
                      slot="reference"
                    >{{ scope.row.LogMessage.length>20?scope.row.LogMessage.substr(0,20)+'...':scope.row.LogMessage }}</span>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="120" align="center">
                <template slot-scope="scope">
                  <template>
                    <el-button
                      @click="queryDetail(scope.$index, scope.row)"
                      type="text"
                      size="small"
                    >查看</el-button>
                  </template>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>

<script>
import MyApis from "../../../apis";
export default {
  name: "ErrorLogList",
  controller: "UI",
  action: "ErrorLogList",
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      UserName: "",
      BeginTime: new Date().format("yyyy-MM-dd 0:00"),
      EndTime: new Date().format("yyyy-MM-dd 23:59"),
      ModuleName: "",
      PageName: ""
    };
  },
  mounted: function() {
    this.search();
    this.logInfo.ActionName = "错误日志查询";
    this.logInfo.LogMessage = "错误日志查询";
    this.logInfo.ModuleName = "日志管理";
    this.logInfo.PageName = "错误日志列表";
   // this.addOperationLog();
  },
  methods: {
    search() {
      let searchInfo = {
        UserName: this.UserName,
        BeginTime:
          this.BeginTime == null ? "0001-01-01T00:00:00" : this.BeginTime,
        EndTime: this.EndTime == null ? "0001-01-01T00:00:00" : this.EndTime,
        ModuleName: this.ModuleName,
        PageName: this.PageName,
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0
      };
      new MyApis.ErrorLogApi()
        .GetItemPagingList(searchInfo)
        .then(r => {
          r = r.data.Data;
          this.tableData = r.PageContents;
          this.total = r.BaseSearch.TotalCount;
        })
        .catch(e => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    //查看
    queryDetail(index, row) {
      this.$router.push({
        path: "/plugin/systemLog/ui/ErrorLogDetail",
        query: { InfoId: row.LogId }
      });
    },
    // 点击查询按钮
    onSearch() {
      if (new Date(this.EndTime) < new Date(this.BeginTime)) {
        this.$message.error("开始时间不能大于结束时间");
        return;
      }
      this.currentPage = 1;
      this.search();
    },
    clearsearch() {
      this.UserName = "";
      this.BeginTime = new Date().format("yyyy-MM-dd 0:00");
      this.EndTime = new Date().format("yyyy-MM-dd 23:59");
      this.ModuleName = "";
      this.PageName = "";
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.search();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    //日期列表展示格式
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd hh:mm:ss");
    }
  }
};
</script>
<style lang="css">
.el-popover {
  background: #00407b !important;
}
</style>
